import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

const $sort = $('#filter-sort');
const $fakeSort = $('select#fake-sort');
const $fakeSortButtons = $('.js-fake-sort-buttons');
const $view = $('#filter-view');
const $fakeView = $('.js-fake-view');
const wNumbPrice = wNumb({
    decimals: 0,
    suffix: Eshop.options.currency.symbol_right
})

let $rangeSlider;

Listing.customCallbacks.beforeFetch = () => {
    Event.dispatch('Listing.customBeforeFetch');
}

function updateFilterBubbles() {
    const withoutFilterBubbles = $('.js-filter-bubbles-item').length < 1;

    if (withoutFilterBubbles) {
        $('.js-filter-bubbles-reset').remove();
    }

    $('.js-filter-bubbles').toggleClass('is-empty', withoutFilterBubbles);
    $('.js-filter-submit-holder').toggleClass('without-bubbles', withoutFilterBubbles);
}

function renderFilterBubbles() {
    updateFilterBubbles();

    Event.on('FilterBubbles.afterRefresh', function () {
        updateFilterBubbles();
    });

    $('body').on('change', '.filter__form [type="checkbox"]', function () {
        updateFilterBubbles();
    });

    // filter bubbles reset hide
    $('body').on('click', '.js-filter-bubbles-item', function () {
        requestAnimationFrame(() => {
            updateFilterBubbles();
        });
    });

    $('body').on('click', '.js-filter-bubbles-reset', function () {
        $('.filter__form').find('[type="reset"]').click();
        updateFilterBubbles();
    });
}

const renderMultiselect = () => {
    $('#filter .c-form__item--select select').not('.is-loaded').each(function () {
        const $select = $(this);
        let options = {
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown"><span class="multiselect-selected-text"></span><i class="ico ico-triangle-down is-on-right"></i></button>',
            },
            buttonClass: 'c-btn has-icon',
            enableHTML: true
        };

        if ($select.closest('#filter').length) {
            const moreText = $select.data('more-text')
            const lessText = $select.data('less-text')

            options.templates.ul = `
                <r-more-items r-more-items-self-target class="multiselect-container dropdown-menu" data-more-text="${moreText}" data-less-text="${lessText}">
                    <button type="button" class="c-link c-link--primary is-more has-icon" r-more-items-trigger>
                        <span r-more-items-trigger-text>${moreText}</span>
                        <i class="ico ico-chevron-down is-on-right"></i>
                    </button>
                </r-more-items>
            `;
            options.templates.filter = `
                <div class="multiselect-item multiselect-filter">
                    <div class="c-form__item c-form__item--text">
                        <input class="c-form__input multiselect-search" type="text">
                        <i class="ico ico-search"></i>
                    </div>
                </div>
            `;
            options.filterPlaceholder = $select.data('filter-text');
            options.enableCaseInsensitiveFiltering = true;
            options.onFiltering = (input) => {
                const $input = $(input);
                const $dropdownMenu = $input.closest('.dropdown-menu')

                if ($input.val()) {
                    $dropdownMenu.addClass('is-filtering');
                }
                if (!$input.val()) {
                    $dropdownMenu.removeClass('is-filtering');

                    $dropdownMenu.find('li').each(function() {
                        $(this).css('display', '');
                    });
                }
            };
        }

        $select.multiselect(options);
        $select.addClass('is-loaded');
    });

    requestAnimationFrame(() => {
        addMultiselectCounts()
        addFilterAndMore()
    })
}

const addMultiselectCounts = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $select = $(this),
            $options = $select.find('option'),
            $dropdownMenu = $select.next().find('.dropdown-menu'),
            type = $select.data('type');

        $options.each(function () {
            const $option = $(this),
                count = $option.data('count'),
                link = $option.data('link'),
                value = $option.val(),
                $fakeInput = $dropdownMenu.find('input[value="' + value + '"]'),
                $fakeInputLabel = $fakeInput.parent();

            if (count && !$fakeInputLabel.find('.count').length) {
                $fakeInputLabel.append(count);
                $fakeInput.parents('a')
                    .attr('data-element', 'filterItem')
                    .attr('data-type', type)
                    .attr('data-field-value', value)
                    .attr('data-count', count.replace(/<[^>]*>?/gm, '').replace(/[()]/g, ''));

                if (link) {
                    $fakeInput.parents('a').attr('href', link);
                }
            }
        });
    });
}

const addFilterAndMore = () => {
    $('#filter').find('select[type="multiselect"]').each(function () {
        const $dropdownMenu = $(this).next().find('.dropdown-menu');
        const $options = $dropdownMenu.find('li');

        if ($options.length > 10) {
            $dropdownMenu.addClass('hide-items');
            $options.each(function(key, item) {
                if (key > 7) {
                    $(this).addClass('is-hidden');
                }
            });
        }
    });
}

function updateRangeCallback(selectors, values, sliderInstance) {
    $(selectors.from).val(values[0]);
    $(selectors.to).val(values[1]);

    Filter.submit();
}

function createPriceRange() {
    const $elem = $('.js-range-price');
    const $slider = $elem.find('.range-slider__slider');
    const maxValue = parseInt($elem.attr('data-max'));
    const minValue = parseInt($elem.attr('data-min'));
    const fromValue = parseInt($elem.attr('data-from'));
    const toValue = parseInt($elem.attr('data-to'));

    if (!$slider.length) {
        return false;
    }

    $rangeSlider = noUiSlider.create($slider[0], {
        start: [fromValue, toValue],
        range: {
            'min': [minValue],
            'max': [maxValue]
        },
        margin: 1,
        connect: true,
        tooltips: [
            wNumbPrice,
            wNumbPrice
        ],
        format: wNumbPrice,
        step: 1
    });

    $rangeSlider.on('change', function (values, handle) {
        updateRangeCallback({
            from: '[name="filter[price][from]"]',
            to: '[name="filter[price][to]"]'
        }, values, this);
    });

    $('#filter-price-from').on('change', function () {
        const $priceToInput = $('#filter-price-to');
        const min = parseInt($(this).attr('min'));
        const max = parseInt($priceToInput.attr('max'));
        const inputToValue = parseInt($priceToInput.val());
        const hasInputToValue = typeof inputToValue === 'number' && !isNaN(inputToValue)

        let value = parseInt($(this).val());

        if (value < min) {
            value = min;
        }
        else if (value > inputToValue) {
            value = inputToValue;
        }

        $(this).val(wNumbPrice.to(value));

        if (!hasInputToValue) {
            $priceToInput.val(wNumbPrice.to(max));
        }

        $rangeSlider.set([value, null]);
    });

    $('#filter-price-to').on('change', function () {
        const $priceFromInput = $('#filter-price-from');
        const min = parseInt($priceFromInput.attr('min'));
        const max = parseInt($(this).attr('max'));
        const inputFromValue = parseInt($priceFromInput.val());
        const hasInputFromValue = typeof inputFromValue === 'number' && !isNaN(inputFromValue)

        let value = parseInt($(this).val());

        if (value > max) {
            value = max;
        }
        else if (value < inputFromValue) {
            value = inputFromValue;
        }

        $(this).val(wNumbPrice.to(value));

        if (!hasInputFromValue) {
            $priceFromInput.val(wNumbPrice.to(min));
        }

        $rangeSlider.set([null, value]);
    });
}

const changeFakeSortButton = (value) => {
    $fakeSortButtons.find('.c-btn').removeClass('is-active');
    $fakeSortButtons.find(`.c-btn[data-value="${value}"]`).addClass('is-active');
}

const updateTitle = (data) => {
    const $titleElemHolder = $('.js-catalog-title');

    if (!$titleElemHolder.length) {
        return
    }

    const $titleElem = $titleElemHolder.find('h1');
    const baseName = $titleElemHolder.attr('data-name');
    let name = baseName;

    if (data.entity && data.entity.heading) {
        name = data.entity.heading;
    } else if (data.filtered_parameters) {
        name = baseName + " " + Object.values(data.filtered_parameters).join(" ");
    }

    if (!name) {
        return;
    }

    $titleElem.html(name);

    var title = document.title.split(" | ");

    document.title = name + " | " + title[1];
}

Event.on('Listing.customBeforeFetch', function() {
    if ($('.listing__holder').length) {
        $('.listing__holder').addClass('is-loading');
    }
    if ($('.c-msg.is-empty.listing').length) {
        $('.c-msg.is-empty.listing').addClass('is-loading');
    }
});

Event.on('Listing.fetchedData', function (data) {
    updateTitle(data);

    requestAnimationFrame(() => {
        if ($('.listing__holder').length) {
            $('.listing__holder').removeClass('is-loading');
        }

        if ($('.pager__load').length) {
            $('.pager__load').removeClass('is-loading');
        }
    })

    const $listingCount = $('.js-listing-count');

    if ($listingCount.length) {
        $listingCount.each(function () {
            const $countElem = $(this);
            let countHtml = data.count;

            if ($countElem.hasAttr('data-plural')) {
                const listingPlural = $countElem.data('plural');

                countHtml = data.count + ' ' + Format.plural(listingPlural[0], listingPlural[1], listingPlural[2], data.count);
            }

            if ($countElem.hasAttr('data-template')) {
                countHtml = $countElem.data('template').replace(':value:', countHtml);
            }

            $countElem.html(countHtml)
        });
    }
});

FilterBubbles.create = function(filterSelector, options) {
    this.template = options.template;
    this.clearFilterTemplate = options.clearFilterTemplate;

    this.initialize();

    Event.dispatch('FilterBubbles.created');

    return this;
}

FilterBubbles.add = function(data) {
    if (!data.content) {
        return;
    }

    if ($(this.container).find('.js-filter-bubbles-reset').length == 0) {
        $(this.container).prepend( _.template(this.clearFilterTemplate)({
            _class: ''
        }) );
    }

    $(this.container).append( _.template(this.template)(data));
    $('[data-element="filterBubbles"]').attr('data-count', $(this.holder).size());

    Event.dispatch('FilterBubbles.added');
}

$(function () {
    renderMultiselect();
    renderFilterBubbles();

    if ($('.filter-price').length > 0) {
        createPriceRange();
    }

    // fake sort
    const sortValue = $sort.val();
    $fakeSort.val(sortValue);
    changeFakeSortButton(sortValue);

    $fakeSort.on('change', function () {
        const value = $(this).val();

        $sort.val(value).trigger('change');
    });

    $fakeSortButtons.on('click', '.c-btn', function() {
        const value = $(this).data('value');

        changeFakeSortButton(value);
        $sort.val(value).trigger('change');
    });

    $fakeView.on("click", function () {
        const viewValue = $(this).data('value');

        $view.val(viewValue).trigger('change');
    });

    Event.on('Listing.changeView', function () {
        const $view = $('#filter-view'),
            value = $view.val();

        $('.js-fake-view').removeClass('is-active');
        $('.js-fake-view#' + value).addClass('is-active');

        $(".products")
            .removeClass("products--row")
            .removeClass("products--grid");
        $(".products").addClass("products--" + value);

        $(".products .js-thumb")
            .removeClass("is-row")
            .removeClass("is-grid");
        $(".products .js-thumb").addClass("is-" + value);
    });

    // filter reset
    Event.on("Filter.reset", function () {
        const $inputFrom = $('#filter-price-from'),
            fromValue = Number($inputFrom.attr('min')),
            $inputTo = $('#filter-price-to'),
            toValue = Number($inputTo.attr('max'));

        $inputFrom.val(fromValue);
        $inputTo.val(toValue);

        if ($rangeSlider) {
            $rangeSlider.set([fromValue, toValue]);
        }

        $('.js-filter-price-range:checked').prop('checked', false);
    });

    $('.js-filter-price-range').on('change', function () {
        const $checkedInput = $('.js-filter-price-range:checked'),
            priceArray = $checkedInput.val().split(';'),
            actualMin = parseFloat(priceArray[0]),
            actualMax = parseFloat(priceArray[1]);

        let min = 99999,
            max = 0;

        if (actualMin < min) {
            min = actualMin;
        }

        if (actualMax > max) {
            max = actualMax;
        }

        $('#filter-price-from').val(min);
        $('#filter-price-to').val(max);

        $rangeSlider.set([min, max]);

        Filter.submit();
    });

    $(document).on('click', '.pager__list a', function(event) {
        event.preventDefault();

        $.get($(this).attr('href'), {}, function(data) {
            Listing.callbacks.update(data);
        }, 'json');

        $(this).addClass('is-loading');

        if ($('.listing__holder').length) {
            $('.listing__holder').addClass('is-loading');
        }
    });

    $(document).on('click', '.pager__load', function(event) {
        $(this).addClass('is-loading');
    });

    $('.js-tips-video-trigger').on('click', function() {
        $(this).closest('.js-lightbox-holder').find('.js-lightbox').first().trigger('click');
    });

    // TODO: nejaky chat na lubici, mozno sa da pouzit na footer chat
    //
    // const chatTrigger = document.querySelector('.js-trigger-chat');

    // if (chatTrigger) {
    //     chatTrigger.addEventListener('click', function (event) {
    //         const iframeChat = document.getElementById('chat-application-iframe');

    //         event.preventDefault();

    //         if (iframeChat) {
    //             iframeChat.contentWindow.document.querySelector('.MuiButtonBase-root').click()
    //         }
    //     });
    // }
});
